<template>
	<div>
		<core-loading
			v-if="isLoading || shouldFetchRuleData"
			class="rulesets-loading"
			size="40px"
		/>

		<div
			v-if="showRules"
			class="omapi-rules-list__summary"
			:style="rulesetWrapper"
			ref="rulesWrap"
		>
			<div
				v-for="(ruleset, index) in rulesets"
				:key="index"
				class="omapi-rules-list__ruleset"
			>
				<h2 class="omapi-rules-list__ruleset-title" v-if="rulesets.length > 1"><strong>{{ ruleset.name }}</strong></h2>
				<campaigns-rule-summary-ruleset
					:ruleset="ruleset"
					:index="index"
					@changedOutput="resetHeight"
				/>
			</div>

			<div v-if="showToggle" :style="rulesetFadeOut" class="omapi-rules-list__fadeout"></div>
		</div>

		<div
			v-if="showToggle"
			class="omapi-rules-list__toggle"
			@click="min = !min"
		>
			<core-button type="secondary">{{ min ? 'More' : 'Less' }}</core-button>
		</div>

		<transition name="component-fade-slow">
			<core-alert v-if="isError" type="warn" style="flex-direction: column;">
				<div class="alert-message" v-html="isError"/>
			</core-alert>
		</transition>
	</div>
</template>

<script lang="js">
import { appData } from '@/utils'
import { campaign } from '@/campaigns/mixins/campaign'
import { bulkWatchHandler } from '@/components/utils'
import { getErrorMessage } from 'optinmonster-js-library/src/vue/campaigns/store/alerts/mutations'

/**
 * Campaign Rules Summary
 * @displayName Campaign Rules Summary
 * @since 2.0.0
 */
export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * Campaign
		 */
		campaign : Object,
	},
	data () {
		return {
			min    : false,
			height : 0,
		}
	},
	mounted () {
		this.fetchCampaignRuleCampaigns()
		this.min = false
		this.setHeight()
	},
	watch    : bulkWatchHandler([ 'id', 'hasRules', 'showRules' ], 'resetHeight'),
	computed : {
		shouldFetchRuleData () {
			return !this.$store.getters.isFetching('rulesetData') && !this.$store.getters.isFetched('rulesetData')
		},
		isLoading () {
			return this.$store.getters.isLoading('rulesets')
		},
		showToggle () {
			return this.hasRules && 120 < this.height
		},
		rulesets () {
			return this.campaign.rulesets
		},
		isError () {
			return this.rulesets instanceof Error
				? getErrorMessage(this.rulesets)
				: false
		},
		hasRules () {
			return !this.isError && !this.isLoading && this.rulesets && 0 < this.rulesets.length
		},
		showRules () {
			return this.hasRules && !this.shouldFetchRuleData
		},
		rulesetWrapper () {
			return {
				height    : this.min ? '120px' : 'auto',
				overflowY : this.min ? 'hidden' : 'auto',
			}
		},
		rulesetFadeOut () {
			return {
				display : this.min ? 'block' : 'none',
			}
		},
		rulesetData () {
			return appData.get('rulesetData')
		},
		campaignRules () {
			return this.getRules(rule => {
				return this.rulesetData.isCampaignRule(rule) &&
					!rule.operator.includes('folder')
			})
		},
	},
	methods : {
		fetchCampaignRuleCampaigns () {
			this.$store.dispatch('campaigns/fetchRulesetData')

			const allValues = this.campaignRules.map(r => r.value)

			// Merge all the values.
			const campaignIds = [].concat.apply([], allValues)

			this.$store.dispatch('campaigns/fetchCampaigns', {
				campaignIds,
				loading : false,
			})
		},
		resetHeight () {
			this.min = false
			this.$nextTick(() => {
				this.setHeight()
			})
		},
		setHeight () {
			this.height = this.$get('$refs.rulesWrap.offsetHeight', 0)
			this.min = true
		},
	},
}

</script>

<style lang="scss" scoped>
	.omapi-rules-list {
		&__ruleset {
			max-width: 100%;
			overflow-wrap: break-word;
			margin-top: 15px;

			&-title {
				font-size: 14px;
				margin: 0 0 8px;
			}

			&:first-child {
				margin-top: 0;
			}
		}
		&__summary {
			position: relative;
		}
		&__fadeout {
			background: linear-gradient(transparent, #fff);
			bottom: 0;
			display: block;
			height: 50px;
			left: 0;
			position: absolute;
			width: 100%;
		}
	}
	.rulesets-loading {
		margin: 0 0 20px;
		// background-position: left;
	}
</style>
